import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

import errorBoundaryPng from '../assets/images/png/img_error_boundary.png';

const ErrorContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans';
  color: #d8d8d8;
`;

const ImageErrorBoundary = styled('img')`
  width: 120px;
  height: 120px;
`;

const TextTittle = styled('div')`
  font-family: 'Noto Sans';
  font-style: bold;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 4px;
`;

const TextInner = styled('div')`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
`;

interface ErrorBoundaryComponentProps {
  component: JSX.Element;
  [key: string]: any;
}

const ErrorBoundaryContainer = (props: ErrorBoundaryComponentProps) => {
  const { component, ...rest } = props;
  const { t } = useTranslation();

  const boundaryKey =
    rest.key || rest.boundaryKey || Math.random().toString(36).slice(2);

  return (
    <ErrorBoundary
      fallback={
        <ErrorContainer key={boundaryKey}>
          <ImageErrorBoundary src={errorBoundaryPng} alt="error icon" />
          <TextTittle> {t('errorJson.somethingWentWrong')}..</TextTittle>
          <TextInner> {t('errorJson.reportToTheTeam')}</TextInner>
        </ErrorContainer>
      }
    >
      {component}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryContainer;
